import { GpxPoint, TrackStats } from '../types';

export function computeTrackStats(points: GpxPoint[]): TrackStats {
    if (points.length === 0) {
        return {
            n: 0,
            totalDist: 0,
            duration: 0,
            maxSpeed: 0,
            avgSpeed: 0,
            maxAccel: 0,
            minAccel: 0,
            avgAbsAccel: 0,
            minEle: null,
            maxEle: null,
            eleGain: 0,
            eleLoss: 0
        };
    }

    const last = points[points.length - 1];
    const first = points[0];
    const totalDist = last.cumDist;
    const duration =
        first.t !== null && last.t !== null ? (last.t - first.t) / 1000 : 0;

    let maxSpeed = 0;
    let sumSpeed = 0;
    let nSpeed = 0;
    let maxAccel = 0;
    let minAccel = 0;
    let sumAbsAccel = 0;
    let nAccel = 0;
    let minEle: number | null = null;
    let maxEle: number | null = null;
    let eleGain = 0;
    let eleLoss = 0;
    let prevEle: number | null = null;

    for (const p of points) {
        const sp = p.speed !== null ? p.speed : p.computedSpeed;
        if (sp !== null && !Number.isNaN(sp)) {
            if (sp > maxSpeed) maxSpeed = sp;
            sumSpeed += sp;
            nSpeed++;
        }
        if (p.acceleration !== null && !Number.isNaN(p.acceleration)) {
            if (p.acceleration > maxAccel) maxAccel = p.acceleration;
            if (p.acceleration < minAccel) minAccel = p.acceleration;
            sumAbsAccel += Math.abs(p.acceleration);
            nAccel++;
        }
        if (p.ele !== null) {
            if (minEle === null || p.ele < minEle) minEle = p.ele;
            if (maxEle === null || p.ele > maxEle) maxEle = p.ele;
            if (prevEle !== null) {
                const d = p.ele - prevEle;
                if (d > 0) eleGain += d;
                else eleLoss += d;
            }
            prevEle = p.ele;
        }
    }

    return {
        n: points.length,
        totalDist,
        duration,
        maxSpeed,
        avgSpeed: nSpeed ? sumSpeed / nSpeed : 0,
        maxAccel,
        minAccel,
        avgAbsAccel: nAccel ? sumAbsAccel / nAccel : 0,
        minEle,
        maxEle,
        eleGain,
        eleLoss
    };
}
